import Icon from 'modules/common/components/Icon';

import {
  ListItem,
  ItemLabel,
  ItemContent,
  ItemDescription,
  ItemContentContainer,
  CheckBox,
  ItemImage,
  AddItemIconContainer,
  AddItemIconWrapper,
} from './DropDown.style';

export const dropDownListToggler = (optionsList, componentName) => {
  if (optionsList && optionsList.length) {
    const list = document.getElementById(`dropdown-list-${componentName}`);
    if (list.style.display === 'none') {
      list.style.display = 'block';
      if (document.getElementById(`dropdown-list-items-${componentName}`))
        document.getElementById(`dropdown-list-items-${componentName}`).focus();
    } else {
      list.style.display = 'none';
    }
  }
};

export const dropDownListTogglerBySearchOptions = (optionsList, listId) => {
  if (optionsList && optionsList.length) {
    const list = document.getElementById(listId);
    if (list.style.display === 'none') {
      list.style.display = 'block';
    }
  }
};

export const renderSelectedOptions = (selectedOptionsList, isMultipleSelection) => {
  if (selectedOptionsList.length) {
    if (isMultipleSelection) {
      const firstTwoItems = selectedOptionsList.slice(0, 3);
      let composedValue = '';
      firstTwoItems.forEach(item => {
        if (!composedValue) {
          composedValue = item.fieldValue;
        } else {
          composedValue += `, ${item.fieldValue}`;
        }
      });
      composedValue += selectedOptionsList.length > 3 ? ` +${selectedOptionsList.length - 3}` : '';
      return composedValue;
    }
    return selectedOptionsList[0].fieldValue;
  }
  return '';
};

export const renderDropDownList = (
  optionsList,
  isMultipleSelection,
  callback,
  extendedStyle,
  componentName,
  language,
) => {
  let mappedOptions = [];

  if (optionsList && optionsList.length) {
    mappedOptions = optionsList.map(option => (
      <ListItem
        key={`${option.key}-${option.value}`}
        extendDropDownListItem={extendedStyle.extendDropDownListItem}
        /* onClick={() => {
          if (option.onClickItemAction) {
            option.onClickItemAction();
            dropDownListToggler(optionsList, `dropdown-list-${componentName}`);
          } else {
            callback(option);
          }
        }} */
        isMultipleSelection={isMultipleSelection}
      >
        {option.itemImage && <ItemImage src={option.itemImage} />}
        <ItemContentContainer>
          {isMultipleSelection && <CheckBox type="checkbox" checked={option.isChecked} />}
          <ItemContent>
            <ItemLabel>{option.fieldValue}</ItemLabel>
            {option.description && (
              <ItemDescription language={language}>{option.description}</ItemDescription>
            )}
          </ItemContent>
        </ItemContentContainer>
        <AddItemIconContainer
          onClick={() => {
            if (!option.isSelected) {
              callback(option);
            }
          }}
          isSelected={option.isSelected}
        >
          <AddItemIconWrapper>
            <Icon icon={option.isSelected ? 'e92a' : 'e932'} size={14} />
          </AddItemIconWrapper>
        </AddItemIconContainer>
      </ListItem>
    ));
  }

  return mappedOptions;
};
